import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { api } from "../../api/api";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { IEdiXmlTrackingRecord, IEdiXmlTrackingStats } from "./ediXmlTracking.types";

export const FETCH_EDI_XML_TRACKING_LIST_PROGRESS =
  "FETCH_EDI_XML_TRACKING_LIST_PROGRESS";
export const FETCH_EDI_XML_TRACKING_LIST_SUCCESS =
  "FETCH_EDI_XML_TRACKING_LIST_SUCCESS";
export const FETCH_EDI_XML_TRACKING_LIST_FAILED =
  "FETCH_EDI_XML_TRACKING_LIST_FAILED";
export const CLEAR_EDI_XML_TRACKING_STATE = "CLEAR_EDI_XML_TRACKING_STATE";

export const FETCH_EDI_XML_TRACKING_STATS_PROGRESS =
  "FETCH_EDI_XML_TRACKING_STATS_PROGRESS";
export const FETCH_EDI_XML_TRACKING_STATS_SUCCESS =
  "FETCH_EDI_XML_TRACKING_STATS_SUCCESS";
export const FETCH_EDI_XML_TRACKING_STATS_FAILED =
  "FETCH_EDI_XML_TRACKING_STATS_FAILED";

export const fetchEdiXmlTrackingListProgress = () =>
  action(FETCH_EDI_XML_TRACKING_LIST_PROGRESS);
export const fetchEdiXmlTrackingListSuccess = (
  list: IEdiXmlTrackingRecord[],
  totalRecords: number
) =>
  action(FETCH_EDI_XML_TRACKING_LIST_SUCCESS, {
    list,
    totalRecords,
  });
export const fetchEdiXmlTrackingListFailed = () =>
  action(FETCH_EDI_XML_TRACKING_LIST_FAILED);
export const clearEdiXmlTrackingState = () =>
  action(CLEAR_EDI_XML_TRACKING_STATE);

export const fetchEdiXmlTrackingStatsProgress = () =>
  action(FETCH_EDI_XML_TRACKING_STATS_PROGRESS);
export const fetchEdiXmlTrackingStatsSuccess = (stats: IEdiXmlTrackingStats) =>
  action(FETCH_EDI_XML_TRACKING_STATS_SUCCESS, { stats });
export const fetchEdiXmlTrackingStatsFailed = () =>
  action(FETCH_EDI_XML_TRACKING_STATS_FAILED);

export const fetchEdiXmlTrackingListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(saveLoaderProgress());
      dispatch(fetchEdiXmlTrackingListProgress());

      let finalUrl = `/csio/get-edi-xml-tracking-records?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;

      if (status && status !== "-1") {
        finalUrl += `&status=${status}`;
      }

      if (searchValue.length > 0) {
        finalUrl += `&advanceFilter=${JSON.stringify(searchValue)}`;
      }

      const res = await api.get(finalUrl);
      const data: IEdiXmlTrackingRecord[] = res.data.data;
      const totalRecords = res.data.currentRecords;

      dispatch(fetchEdiXmlTrackingListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchEdiXmlTrackingListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response?.data?.message || "Failed to fetch EDI XML tracking records",
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const fetchEdiXmlTrackingStatsAsync =
  (): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(fetchEdiXmlTrackingStatsProgress());

      const res = await api.get("/csio/edi-xml-tracking/stats");
      const stats: IEdiXmlTrackingStats = res.data.data.totals;

      dispatch(fetchEdiXmlTrackingStatsSuccess(stats));
    } catch (err: any) {
      dispatch(fetchEdiXmlTrackingStatsFailed());
      dispatch(
        showMessage({
          type: "error",
          message:
            err.response?.data?.message ||
            "Failed to fetch EDI tracking stats",
          displayAs: "snackbar",
        })
      );
    }
  };
